import React, { useEffect, useRef, useState } from "react";
import anime from "animejs";
import { Group } from "three";

import { Circle } from "./Circle";
import { ActionButton } from "./ActionButton";
import { AudioVisualizer } from "./AudioVisualiser";
import { State } from "../../core";
import {
  INDICATOR_SHRINK_DURATION,
  SHRINK_TRAVEL_DELAY,
  CENTER_TRAVEL_DURATION
} from "../../constants";

interface LocusProps {
  state: State;
  isRecorderRecording: boolean;
  onActionClick: () => void;
}

export const Locus: React.FC<LocusProps> = React.memo(
  ({ state, isRecorderRecording, onActionClick }) => {
    let groupRef = useRef<Group>();
    let [lastClickAt, setLastClickAt] = useState(-1);

    useEffect(() => {
      let animation: anime.AnimeInstance;
      if (state.state === "sending" || state.state === "sent") {
        animation = anime({
          targets: (groupRef.current as Group).position,
          y: 5,
          delay: INDICATOR_SHRINK_DURATION + SHRINK_TRAVEL_DELAY,
          duration: CENTER_TRAVEL_DURATION,
          easing: "easeInOutCubic"
        });
      } else {
        animation = anime({
          targets: (groupRef.current as Group).position,
          y: 0,
          duration: CENTER_TRAVEL_DURATION,
          easing: "easeInOutCubic"
        });
      }
      return () => {
        animation.pause();
      };
    }, [state]);

    function isActionable() {
      return (
        state.state === "start" ||
        state.state === "restart" ||
        state.state === "microphoneRequestFailed" ||
        state.state === "sendingFailed" ||
        state.state === "recording" ||
        state.state === "pending"
      );
    }

    function onClick() {
      setLastClickAt(Date.now);
      onActionClick();
    }

    return (
      <group ref={groupRef}>
        {isActionable() && <ActionButton onClick={onClick} />}
        <AudioVisualizer state={state} />
        <Circle
          state={state}
          isRecorderRecording={isRecorderRecording}
          lastClickAt={lastClickAt}
        />
      </group>
    );
  }
);
